import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import RingChart from '../RingChart';
import { RGB_COLORS } from '../../common/constants';
import classNames from 'classnames';
import NumberFormat from 'react-number-format';
import { TYPE_COLORS } from '../../common/constants';
import keyBy from 'lodash/keyBy';
import get from 'lodash/get';
import Color from 'color';

const useStyles = makeStyles(theme => ({
  resultSection: {
    display: 'grid',
    gridTemplateColumns: '1fr 0.5fr',
  },
  first: {
    gridColumn: '1 / 2',
    marginLeft: -40,
  },
  second: {
    alignSelf: 'center',
    gridColumn: '2 / 3',
    marginLeft: '-35px',
    marginBottom: 70,
  },
  field: {
    padding: 10,
    borderRadius: 20,
  },
  actual: ({ typeColor }) => ({
    background: typeColor
      ? Color(typeColor.bgColor)
          .lighten(0.2)
          .string()
      : 'grey',
    color: RGB_COLORS.greenText,
  }),
  target: ({ typeColor }) => ({
    background: typeColor ? typeColor.bgColor : 'grey',
    color: RGB_COLORS.yellowText,
    marginBottom: 10,
  }),
}));

const Result = ({ label = '-', actual = 0, target = 0, prefix = '' }) => {
  const [{ typeColorsByLabel }, setState] = React.useState({ typeColorsByLabel: {} });

  const classes = useStyles({ typeColor: typeColorsByLabel[label] });

  React.useEffect(() => {
    setState(oldState => ({
      ...oldState,
      typeColorsByLabel: keyBy(TYPE_COLORS, 'label'),
    }));
  }, []);

  console.log('>>ResultsProgress/Result::', 'label', label, typeColorsByLabel); //TRACE

  const getPercentage = (actual, target) => {
    if (actual && target) return Math.floor((actual / target) * 100);
    return 0;
  };
  return (
    <div className={classes.resultSection}>
      <div className={classes.first}>
        <RingChart
          values={[getPercentage(actual, target)]}
          size={250}
          forceColor={get(typeColorsByLabel, [label, 'bgColor'])}
        />
      </div>
      <div className={classes.second}>
        <Typography style={{ fontWeight: 600, minWidth: 145 }}>{label}</Typography>
        <Typography className={classNames(classes.field, classes.target)}>
          <span style={{ marginRight: 30 }}>Target</span>
          <NumberFormat
            displayType="text"
            prefix={prefix}
            value={target ? target : '00.0'}
            fixedDecimalScale
            decimalScale={1}
            thousandSeparator
          />
        </Typography>
        <Typography className={classNames(classes.field, classes.actual)}>
          <span style={{ marginRight: 30 }}>Actual</span>
          <NumberFormat
            displayType="text"
            prefix={prefix}
            value={actual ? actual : '00.0'}
            fixedDecimalScale
            decimalScale={1}
            thousandSeparator
          />
        </Typography>
      </div>
    </div>
  );
};

export default Result;
